/* We need messages for validation */
const messages = {
  decimal: '{attribute} should only contain numeric values.',
  email: '{attribute} should be a valid e-mail address.',
  integer: '{attribute} should only contain numeric values.',
  maxLength: '{attribute} can\'t contain more than {max} characters.',
  maxValue: '{attribute} should be less than {max}.',
  minLength: '{attribute} can\'t contain less than {min} characters.',
  minValue: '{attribute} should be higher than {min}.',
  numeric: '{attribute} should only contain numeric values.',
  required: '{attribute} can\'t be empty.',
  uniqueEmail: 'This e-mail address is already in our database.'
}

export default messages



// WEBPACK FOOTER //
// ./src/validation/messages.js